// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__U0TL-","header":"PatientQuestionnaire_header__2vI4D","info":"PatientQuestionnaire_info__DlO7m"};